import React, { type FC } from 'react'
import { Button, type IButtonProps } from 'shared/ui'

type ITestSMSBtnProps = {
  onClick: IButtonProps['onClick']
  disabled: IButtonProps['disabled']
} & IButtonProps

export const TestSMSBtn: FC<ITestSMSBtnProps> = ({ onClick, disabled, ...props }) => (
  <Button
    text={'Test'}
    icon={'testSMS'}
    onClick={onClick}
    contained={'secondary'}
    size={'medium'}
    disabled={disabled}
    {...props}
  />
)
